/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { ServiceResult } from 'schemas/ServiceResultSchema'
import { useDashboardWidgetData } from '../../../../hooks/useWidgetState'
import ErrorMessage from '../../../share/ErrorMessage'
import ErrorCode from '../../../../enums/ErrorCode'

const getErrorCode = (data: ServiceResult) => data.results?.[0]?.error?.errorCode

const TopicIndexNotReadyGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData(widgetId)
  const { t } = useTranslation()

  if (
    widgetData.data?.some(
      (d) => getErrorCode(d as ServiceResult) === ErrorCode.TOPIC_MANAGER_INDEX_NOT_READY_ERROR
    )
  )
    return <ErrorMessage>{t('topicLoading')}</ErrorMessage>

  return children
}

export default TopicIndexNotReadyGuard
